module.exports = __webpack_public_path__ + "img/px_hover.c3fbcbd5.png";